import { createReducer } from "redux-create-reducer";
import { PAYMENT_ACTIONS } from "./paymentActions";
import { ASYNC_STATE } from "../../constants/Constants";
import { LOCATION_CHANGE } from "react-router-redux";
const INITIAL_STATE = {
    isSaving: false,
    error: null,
    fieldErrors: [],
    receipt: {
        id: null,
        state: ASYNC_STATE.NONE,
        data: null,
        error: null
    },
    cancel: {
        id: null,
        isCancelling: false,
        error: null
    }
};
/**
 * Reducer creation and export.
 * Uses the constants above to define new state for each action
 */
export default createReducer(INITIAL_STATE, {
    [PAYMENT_ACTIONS.PAYMENT_CREATE_STARTED](state, _action) {
        return {
            ...state,
            isSaving: true,
            error: null,
            fieldErrors: []
        };
    },
    [PAYMENT_ACTIONS.PAYMENT_CREATE_FAILED](state, action) {
        return {
            ...state,
            isSaving: false,
            error: action.payload
        };
    },
    [PAYMENT_ACTIONS.PAYMENT_CREATE_SUCCEEDED_FALSE](state, action) {
        return {
            ...state,
            isSaving: false,
            fieldErrors: action.payload
        };
    },
    [PAYMENT_ACTIONS.PAYMENT_CREATE_SUCCEEDED_TRUE](state, _action) {
        return {
            ...state,
            error: null,
            fieldErrors: [],
            isSaving: false
        };
    },
    [PAYMENT_ACTIONS.RECEIPT_LOAD_STARTED](state, action) {
        return {
            ...state,
            receipt: {
                ...state.receipt,
                id: action.payload,
                state: ASYNC_STATE.PENDING,
                data: null,
                error: null
            }
        };
    },
    [PAYMENT_ACTIONS.RECEIPT_LOAD_FAILED](state, action) {
        if (action.payload.id === state.receipt.id) {
            return {
                ...state,
                receipt: {
                    ...state.receipt,
                    state: ASYNC_STATE.REJECTED,
                    error: action.payload.error
                }
            };
        }
        return state;
    },
    [PAYMENT_ACTIONS.RECEIPT_LOAD_SUCCEEDED](state, action) {
        if (action.payload.id === state.receipt.id) {
            return {
                ...state,
                receipt: {
                    ...state.receipt,
                    state: ASYNC_STATE.RESOLVED,
                    data: action.payload
                }
            };
        }
        return state;
    },
    [PAYMENT_ACTIONS.RECEIPT_EMAIL_STARTED](state, action) {
        return {
            ...state,
            receipt: {
                ...state.receipt,
                id: action.payload,
                state: ASYNC_STATE.PENDING,
                data: null,
                error: null
            }
        };
    },
    [PAYMENT_ACTIONS.RECEIPT_EMAIL_FAILED](state, action) {
        if (action.payload.id === state.receipt.id) {
            return {
                ...state,
                receipt: {
                    ...state.receipt,
                    state: ASYNC_STATE.REJECTED,
                    error: action.payload.error
                }
            };
        }
        return state;
    },
    [PAYMENT_ACTIONS.RECEIPT_EMAIL_SUCCEEDED](state, action) {
        if (action.payload.id === state.receipt.id) {
            return {
                ...state,
                receipt: {
                    ...state.receipt,
                    state: ASYNC_STATE.RESOLVED,
                    data: action.payload
                }
            };
        }
        return state;
    },
    [PAYMENT_ACTIONS.CANCEL_PAYMENT_STARTED](state, { payload }) {
        return {
            ...state,
            cancel: {
                id: payload.id,
                isCancelling: true,
                error: null
            }
        };
    },
    [PAYMENT_ACTIONS.CANCEL_PAYMENT_SUCCEEDED](state, { payload }) {
        if (state.cancel.id === payload.id) {
            return {
                ...state,
                cancel: {
                    ...state.cancel,
                    isCancelling: false
                }
            };
        }
        return state;
    },
    [PAYMENT_ACTIONS.CANCEL_PAYMENT_FAILED](state, { payload }) {
        if (state.cancel.id === payload.id) {
            return {
                ...state,
                cancel: {
                    ...state.cancel,
                    isCancelling: false,
                    error: payload.error
                }
            };
        }
        return state;
    },
    [LOCATION_CHANGE](state, { payload }) {
        if (payload.pathname.indexOf("/secured/account/") === 0 && state.cancel !== INITIAL_STATE.cancel) {
            return {
                ...state,
                cancel: INITIAL_STATE.cancel
            };
        }
        return state;
    }
});



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/payment/paymentReducer.ts